import {
  ArrowDownUp,
  BadgeCheck,
  BadgeQuestionMark,
  Ban,
  Bell,
  BellOff,
  BellRing,
  BookCheck,
  BookOpen,
  Building2,
  Calendar,
  CalendarCheck,
  ChartGantt,
  ChartLine,
  Check,
  CircleCheck as CheckCircle,
  Clock4,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  CircleArrowRight,
  CircleCheck,
  CircleCheckBig,
  CircleDashed,
  CircleDotDashed,
  CirclePlus,
  CircleQuestionMark,
  CircleX,
  Clipboard,
  ClipboardList,
  Clock,
  CloudUpload,
  Code,
  CodeXml,
  ContactRound,
  Cookie,
  Copy,
  Cpu,
  Download,
  Expand,
  Eye,
  EyeClosed,
  Facebook,
  File,
  FileCheck,
  FileCode,
  FileDown,
  Forward,
  GraduationCap,
  History,
  House,
  IdCardLanyard,
  Info,
  Instagram,
  LayoutGrid,
  LayoutList,
  Library,
  Linkedin,
  LockKeyhole,
  Mail,
  Mails,
  MessageCircle,
  MessageCirclePlus,
  MessageCircleQuestionMark,
  MessagesSquare,
  Minimize2,
  NotebookText,
  Package,
  PanelLeft,
  PanelTop,
  Paperclip,
  PaperclipIcon,
  Pencil,
  Play,
  Plus,
  Plug,
  Power,
  RefreshCw,
  School,
  Search,
  Send,
  Settings,
  SquareCheckBig,
  SquarePen,
  Star,
  TextSearch,
  TrendingUp,
  Trash,
  Trophy,
  TrophyIcon,
  Unplug,
  Upload,
  User,
  UserPlus,
  Users,
  UsersRound,
  UserX,
  Video,
  VolumeOff,
  Wifi,
  WifiOff,
  Workflow,
  X,
  ZoomIn,
  Folder,
  ArrowLeft,
  EllipsisVertical,
  ArrowBigUpDash,
  NotepadText,
  BanIcon,
  Percent,
  Bold,
  Italic,
  Heading1,
  Heading2,
  Heading3,
  List,
  Undo,
  Redo,
  ListOrdered,
  Strikethrough,
  Form,
  Ellipsis,
  MessageCircleX,
  Trash2,
  ThumbsUp,
  ChevronsRight,
  ChevronsLeft,
  LockKeyholeOpen,
  Archive,
  Undo2,
  Pin,
  Smile,
  SendHorizontal,
  MessageSquareDot,
  UserPen,
  Rocket,
  FileText,
} from "lucide-angular";
import {
  IconArrowBackUp,
  IconArrowLeft,
  IconArrowRight,
  IconBan,
  IconBook,
  IconBrandOpenvpn,
  IconChartLine,
  IconCheck,
  IconChevronDown,
  IconChevronRight,
  IconChevronsDownRight,
  IconCode,
  IconEdit,
  IconEye,
  IconFileCheck,
  IconFileStack,
  IconFileTypeCsv,
  IconFileTypePdf,
  IconFileTypeXls,
  IconFlag,
  IconHome,
  IconHourglass,
  IconListNumbers,
  IconLock,
  IconLockCheck,
  IconLockStar,
  IconLogout,
  IconMail,
  IconMenu2,
  IconMessage,
  IconMessage2Question,
  IconPlug,
  IconPlugX,
  IconSchool,
  IconSend,
  IconServer,
  IconStar,
  IconTournament,
  IconUser,
  IconUsers,
  IconUsersGroup,
  IconX,
} from "angular-tabler-icons/icons";

export const LUCIDE_SHARED_ICONS = {
  Settings,
  Bell,
  BellRing,
  BellOff,
  Building2,
  UserPlus,
  UserX,
  Wifi,
  WifiOff,
  User,
  BookOpen,
  Unplug,
  Power,
  NotebookText,
  ChevronDown,
  ChevronUp,
  Check,
  CheckCircle,
  MessagesSquare,
  VolumeOff,
  Info,
  CircleCheck,
  CircleX,
  House,
  UsersRound,
  GraduationCap,
  TrendingUp,
  Code,
  CircleQuestionMark,
  CircleArrowRight,
  ContactRound,
  Users,
  Download,
  FileCheck,
  Workflow,
  CirclePlus,
  BadgeQuestionMark,
  ChevronRight,
  ChevronLeft,
  LayoutGrid,
  LayoutList,
  Facebook,
  Linkedin,
  Instagram,
  Eye,
  Video,
  Star,
  MessageCircleQuestionMark,
  CloudUpload,
  Pencil,
  ClipboardList,
  Forward,
  Paperclip,
  CodeXml,
  MessageCircle,
  MessageCirclePlus,
  X,
  ZoomIn,
  File,
  BookCheck,
  Clock,
  Clock4,
  Cpu,
  FileCode,
  Send,
  Upload,
  PaperclipIcon,
  LockKeyhole,
  BadgeCheck,
  Calendar,
  CalendarCheck,
  IdCardLanyard,
  Mail,
  ChartLine,
  ChartGantt,
  EyeClosed,
  TextSearch,
  Plug,
  CircleDashed,
  CircleDotDashed,
  Mails,
  FileDown,
  PanelLeft,
  PanelTop,
  Play,
  CircleCheckBig,
  Expand,
  Minimize2,
  ArrowDownUp,
  Copy,
  Trophy,
  Trash,
  Plus,
  School,
  Library,
  SquarePen,
  History,
  Cookie,
  Ban,
  SquareCheckBig,
  TrophyIcon,
  Package,
  RefreshCw,
  Clipboard,
  Search,
  Folder,
  ArrowLeft,
  EllipsisVertical,
  ArrowBigUpDash,
  NotepadText,
  BanIcon,
  Percent,
  Bold,
  Italic,
  Heading1,
  Heading2,
  Heading3,
  List,
  Undo,
  Redo,
  ListOrdered,
  Strikethrough,
  Form,
  Ellipsis,
  MessageCircleX,
  Trash2,
  ThumbsUp,
  ChevronsRight,
  ChevronsLeft,
  LockKeyholeOpen,
  Archive,
  Undo2,
  Pin,
  Smile,
  SendHorizontal,
  MessageSquareDot,
  UserPen,
  Rocket,
  FileText,
};

export const TABLER_SHARED_ICONS = {
  IconArrowBackUp,
  IconStar,
  IconFlag,
  IconCode,
  IconMessage,
  IconServer,
  IconCheck,
  IconChevronsDownRight,
  IconFileCheck,
  IconTournament,
  IconX,
  IconEye,
  IconBan,
  IconHourglass,
  IconArrowLeft,
  IconArrowRight,
  IconSend,
  IconListNumbers,
  IconLock,
  IconLockCheck,
  IconLockStar,
  IconMenu2,
  IconHome,
  IconBook,
  IconSchool,
  IconChartLine,
  IconUser,
  IconLogout,
  IconChevronDown,
  IconChevronRight,
  IconUsers,
  IconPlug,
  IconPlugX,
  IconBrandOpenvpn,
  IconMessage2Question,
  IconFileStack,
  IconUsersGroup,
  IconEdit,
  IconFileTypePdf,
  IconFileTypeCsv,
  IconFileTypeXls,
  IconMail,
};
